import { ClientUserSessionState } from '../../../../shared/ClientUserSessionState.ts';
import { globalClientVariables, notificationController, socket } from '../EntryShared.ts';
import { NetworkEnums } from '../../../../shared/GameEnums.ts';
import { showSimpleDialog } from '../ui_popup/showSimpleDialog.ts';
import { showTranslucentOverlay } from '../ui_overlays/showTranslucentOverlay.ts';
import { ClientSocketMessageLoadTest } from './ClientSocketMessageLoadTest.ts';
import { UIDocument } from '../UIDocument.ts';
import { UITopNotificationType } from '../notifications/UINotificationController.ts';
import { COLONIST_VERSION } from '@colonist/types';
import { getMajorVersion } from '@colonist/utils';
import { ClientUserState } from '../ClientUserState.ts';
import { SocketShuffleSend } from './SocketShuffleSend.ts';
import { showSuccessfulPurchaseDialog } from '../ui_popup/showSuccessfulPurchaseDialog.ts';
export class SocketLobbyListen {
    constructor(socketController, socketActionController){
        this.lobbyStateHandlers = new Map();
        this.channelStateHandlers = new Map();
        this.generalStateHandlers = new Map();
        this.socketActionController = socketActionController;
        socketController.setStateHandler(NetworkEnums.State.LobbyStateUpdate, (data)=>{
            var _this_lobbyStateHandlers_get;
            (_this_lobbyStateHandlers_get = this.lobbyStateHandlers.get(data.type)) === null || _this_lobbyStateHandlers_get === void 0 ? void 0 : _this_lobbyStateHandlers_get(data.payload);
        });
        socketController.setStateHandler(NetworkEnums.State.ChannelStateUpdate, (data)=>{
            var _this_channelStateHandlers_get;
            (_this_channelStateHandlers_get = this.channelStateHandlers.get(data.type)) === null || _this_channelStateHandlers_get === void 0 ? void 0 : _this_channelStateHandlers_get(data.payload);
        });
        socketController.setStateHandler(NetworkEnums.State.GeneralStateUpdate, (data)=>{
            var _this_generalStateHandlers_get;
            (_this_generalStateHandlers_get = this.generalStateHandlers.get(data.type)) === null || _this_generalStateHandlers_get === void 0 ? void 0 : _this_generalStateHandlers_get(data.payload);
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.SessionState, (data)=>{
            var _ClientUserState_userState;
            const session = ClientUserSessionState.deserialize(data);
            UIDocument.monitorIfUserInteractedWithSite((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.interactedWithSite);
            socketController.setSession(session);
            this.socketActionController.onStateSessionState();
            SocketShuffleSend.requestShuffleQueueData();
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.LobbyDisconnectData, (data)=>{
            notificationController.showGames(data);
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.AutoRejoinGame, (gameId)=>{
            this.socketActionController.onStateAutoRejoinGame(gameId);
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.SendPopup, (data)=>{
            if (data.body.key == 'strings:popups.errors.newVersion.refreshClient') {
                showTranslucentOverlay({
                    title: {
                        key: 'strings:popups.errors.newVersion.title'
                    },
                    body: {
                        key: 'strings:popups.errors.newVersion.refreshClient'
                    },
                    onConfirm: ()=>window.location.reload()
                });
            } else {
                showSimpleDialog({
                    title: data.title,
                    body: data.body
                });
            }
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.SendBroadcast, (data)=>{
            notificationController.show(data.text, UITopNotificationType.Information);
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.SocketTest, (data)=>{
            ClientSocketMessageLoadTest.processSocketData(data);
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.ShowCornerPopup, (data)=>{
            notificationController.showNotification(data.icon, data.text);
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.ServerUpdating, ()=>{
            showTranslucentOverlay({
                title: {
                    key: 'strings:popups.patchNote.announcement'
                },
                body: {
                    key: 'strings:popups.errors.serverUpdate'
                }
            });
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.ReloadClient, (data)=>{
            setTimeout(()=>window.location.reload(), data.delay);
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.ServerUpdated, (data)=>{
            if (socket.gameListener.databaseGameId == undefined) return;
            if (getMajorVersion(COLONIST_VERSION) == getMajorVersion(data.newServerVersion)) return;
            const updateMessage = {
                key: 'strings:popups.errors.newVersion.newVersionReleasedWarning'
            };
            notificationController.show(updateMessage, UITopNotificationType.Information);
            globalClientVariables.serverUpdated = true;
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.RoomListUpdate, (data)=>{
            this.socketActionController.onRoomListUpdate(data);
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.UserStateUpdate, (data)=>{
            ClientUserState.update(data);
        });
        this.lobbyStateHandlers.set(NetworkEnums.LobbyState.ItemPurchaseSuccessPopup, (data)=>{
            showSuccessfulPurchaseDialog(data);
        });
        this.channelStateHandlers.set(NetworkEnums.ChannelState.ChannelRoomUpdate, (data)=>{
            this.socketActionController.onChannelRoomUpdate(data);
        });
        this.generalStateHandlers.set(NetworkEnums.GeneralState.UpdateOnlineStatus, (data)=>{
            this.socketActionController.onFriendUpdateOnlineStatus(data);
        });
        this.generalStateHandlers.set(NetworkEnums.GeneralState.ReceivedRoomInvites, (data)=>{
            this.socketActionController.onFriendReceivedRoomInvites(data);
        });
        this.generalStateHandlers.set(NetworkEnums.GeneralState.ReceivedFriendRequest, (data)=>{
            this.socketActionController.onFriendReceivedFriendRequest(data);
        });
        this.generalStateHandlers.set(NetworkEnums.GeneralState.RemoveRoomInvite, (roomId)=>{
            this.socketActionController.onFriendRemoveRoomInvite(roomId);
        });
        this.generalStateHandlers.set(NetworkEnums.GeneralState.RoomInviteResponse, (data)=>{
            this.socketActionController.onFriendRoomInviteResponse(data);
        });
        this.generalStateHandlers.set(NetworkEnums.GeneralState.RoomInviteSentSuccessfully, (receiverUserId)=>{
            this.socketActionController.onFriendRoomInviteSentSuccessfully(receiverUserId);
        });
        this.generalStateHandlers.set(NetworkEnums.GeneralState.Notifications, (notificationDataWithUnreadCount)=>{
            this.socketActionController.onNotificationsReceived(notificationDataWithUnreadCount);
        });
        this.generalStateHandlers.set(NetworkEnums.GeneralState.MarkedAsRead, (markedAsReadData)=>{
            this.socketActionController.onMarkedAsRead(markedAsReadData);
        });
    }
}
